
const ContentSection = () => {
  const contentItems = [
    {
      id: 1,
      title: '来店スケジュール',
      description: 'ナナイロメンバーのパチンコホール来店予定をチェック。最新のスケジュール情報をお届けします。',
      icon: 'ri-calendar-line',
      href: '#schedule',
      color: 'from-red-500 to-orange-500'
    },
    {
      id: 2,
      title: 'YouTube動画',
      description: 'ナナイロの実戦動画をYouTubeで配信中。攻略法やプレイテクニックを学べます。',
      icon: 'ri-youtube-fill',
      href: '#youtube',
      color: 'from-red-600 to-red-400'
    },
    {
      id: 3,
      title: 'TikTok',
      description: 'ショート動画でも楽しめるコンテンツを配信。気軽にフォローしてください。',
      icon: 'ri-tiktok-fill',
      href: '#tiktok',
      color: 'from-pink-500 to-purple-500'
    },
    {
      id: 4,
      title: 'X (Twitter)',
      description: '最新情報やリアルタイムな実況を配信。フォローして最新情報をチェック！',
      icon: 'ri-twitter-x-fill',
      href: '#twitter',
      color: 'from-gray-700 to-black'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50" id="content">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* セクションタイトル */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            コンテンツ
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            ナナイロが提供する様々なコンテンツをご紹介します
          </p>
        </div>

        {/* コンテンツグリッド - 2×2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {contentItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <a href={item.href} className="block h-full">
                <div className="bg-white rounded-3xl shadow-md overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 h-full flex flex-col border border-gray-100">
                  {/* アイコン部分 */}
                  <div className="relative overflow-hidden h-48 flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
                    <div className={`w-24 h-24 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center group-hover:scale-110 transition-transform duration-500`}>
                      <i className={`${item.icon} text-white text-5xl w-16 h-16 flex items-center justify-center`}></i>
                    </div>
                  </div>
                  
                  {/* コンテンツ部分 */}
                  <div className="p-8 flex-1 flex flex-col">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-red-500 group-hover:to-orange-500 transition-all duration-300">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed flex-1">
                      {item.description}
                    </p>
                    <div className="mt-6 flex items-center text-red-500 font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <span className="whitespace-nowrap">詳しく見る</span>
                      <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContentSection;
